import { combineReducers } from 'redux'
import landingPage from './landing-page-editor';

const landingPages = combineReducers({
  landingPage,
});

export default landingPages;
